/**
 * represents a Search Query in chunked parts and marks already handled parts with final flag.
 */
export class TransformedQuery {
  /**
   * query if the object is not a composite.
   * @protected
   */
  private readonly _query: string;
  /**
   * marks the query as final, so no further handling is needed.
   * @protected
   */
  private readonly _final: boolean = false;
  /**
   * marks the query as composite to show this query persists of multiple subqueries.
   * @protected
   */
  private readonly _composite: boolean = false;
  /**
   * the parts of the composite query.
   * @protected
   */
  private readonly _parts: TransformedQuery[];

  constructor(query: string | TransformedQuery[], final: boolean = false) {
    this._final = final;

    if (query instanceof String || typeof query === 'string') {
      this._composite = false;
      this._query = query as string;
    } else {
      this._composite = true;
      this._parts = query;
    }
  }

  get parts(): TransformedQuery[] {
    return this._parts;
  }

  get composite(): boolean {
    return this._composite;
  }

  get final(): boolean {
    return this._final;
  }

  public toString(): string {
    return this._composite ? this._parts.map((item) => item.toString()).join(' ') : this._query;
  }
}
